// FloatWhatzapButton.js
import React from "react";
import styles from "./FloatWhatzapButton.module.css";
import img from "../../assets/FloatImages/Podemos Ajudar.png";

const FloatWhatzapButton = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=5585988068633&text=Ol%C3%A1%2C+gostaria+de+informa%C3%A7%C3%B5es+sobre+matr%C3%ADculas+no+Col%C3%A9gio+Alternativo+Cola%C3%A7o&type=phone_number&app_absent=0";

  // função que dispara a conversão e depois abre o WhatsApp
  const trackConversionAndOpen = (link) => {
    const openWhats = () => {
      window.open(link, "_blank", "noopener,noreferrer");
    };

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      let called = false;
      const callback = () => {
        if (called) return;
        called = true;
        openWhats();
      };

      // timeout de segurança: abre o link mesmo se o callback não voltar rápido
      const safety = setTimeout(callback, 1200);

      window.gtag("event", "conversion", {
        send_to: "AW-463883905/xgHfCImZwrwbEIGdmd0B",
        event_label: "WhatsApp - Botão flutuante",
        event_callback: () => {
          clearTimeout(safety);
          callback();
        },
      });
    } else {
      openWhats();
    }
  };

  const handleClick = (e) => {
    e.preventDefault(); // impede a navegação imediata
    trackConversionAndOpen(whatsappLink);
  };

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.floatButton}
      onClick={handleClick}
    >
      <img src={img} alt="Podemos Ajudar" className={styles.icon} />
    </a>
  );
};

export default FloatWhatzapButton;
